import { json, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import "./QuotationOrder.css";
import LoadingScreen from "../../component/LoadingScreen";

const ViewQuotation = () => {
  const navigate = useNavigate();

  let [token, setToken] = useState("");

  const [viewQuotation, setViewQuotation] = useState({});
  const [error, setError] = useState(null);
  const [to, setTo] = useState("");
  const [company, setCompany] = useState("");
  const [re, setRe] = useState("");
  const resource = "view-quotation";
  
useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

    useEffect(() => {
      loadViewQuotation(searchParams.get("param1"));
    },  []);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
  const loadViewQuotation = async (xcpOrderId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/view-quotation?param1=${xcpOrderId}`
      );

      const data = result.data;

      data.orderItemlistByOrderId.forEach((item) => {
        const cable_type_a = item.cable_type_a;
        const a_end_rack_id = item.a_end_rack_id;
        const company_requestor = data.company_requestor;
        const interface_name_a = item.interface_name_a;

        const cable_type_b = item.cable_type_b;
        const b_end_rack_id = item.b_end_rack_id;
        const company_destination = data.company_destination;
        const interface_name_b = item.interface_name_b;

        item.service_description =
          "Location: " +
          data.order_location_name +
          "\nCross Connect using " +
          cable_type_a +
          " :\nFrom: " +
          a_end_rack_id +
          " (" +
          company_requestor +
          ") Interface type " +
          interface_name_a +
          "\n\nCross Connect using " +
          cable_type_b +
          " :\nTo: " +
          b_end_rack_id +
          " (" +
          company_destination +
          ") Interface type " +
          interface_name_b;
      });

      setTo(data.pic_requestor);
      setCompany(data.company_requestor);
      setRe(data.company_requestor + " - " + data.company_destination);

      setViewQuotation(data)
    } catch (error) {
      console.error("Fetch Error Order Detail:", error);
      setError("Fetch Error Order Detail: " + error.message);
    }
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
    
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("id-ID").format(value);
  };

  const handleBackClick = () => {
    navigate("/quotation-list");
  };

  return (
    <div className="container-order-input">
      <h1 className="main-title">Cross Connect Quotation</h1>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Quotation Order Header</h5>
            </div>
            <div className="textbox-gray">
              <label>To</label>
              <input type="text" id="to" value={to} required disabled />
            </div>
            <div className="textbox-gray">
              <label>Company</label>
              <input
                type="text"
                id="company"
                value={company}
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label>Re</label>
              <input type="text" id="re" value={re} required disabled />
            </div>

            <div className="textbox-gray">
              <label>MSA Date</label>
              <input
                type="text"
                value={formatDate(viewQuotation.xcp_quotation_msa_date)}
                disabled
              />
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="orderDate">Date</label>
              <input
                type="text"
                value={formatDate(viewQuotation.xcp_quotation_date)}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label>Quotation No</label>
              <input
                type="text"
                value={viewQuotation.xcp_quotation_no}
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label>Prepared By</label>
              <input type="text" value={viewQuotation.xcp_quotation_prepare_by} disabled />
            </div>
            <div className="radio-button">
              <label>Quotation Currency</label>
              <div >
                <input
                  type="radio"
                  name="connect"
                  id="connect-one"
                  checked={viewQuotation.xcp_quotation_currency === "IDR"}
                  disabled
                  required
                />
                <label>IDR</label>
              </div>
              <div >
                <input
                  type="radio"
                  name="connect"
                  id="connect-two"
                  checked={viewQuotation.xcp_quotation_currency === "USD"}
                  enabled
                  required
                  disabled
                />
                <label>USD</label>
              </div>
            </div>
          </div>
        </div>

        {viewQuotation.orderItemlistByOrderId &&
          viewQuotation.orderItemlistByOrderId.length > 0 &&
          viewQuotation.orderItemlistByOrderId.map((order, index) => (
            <div className="box-two-part">
              <div className="requestor-information">
                <div className="title-order-input">
                  <h5>Cross Connect Service ({index + 1})</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="officeAddress">Item Description</label>
                  <textarea
                    style={{
                      backgroundColor: "lightgrey",
                      color: "black",
                      height: "190px",
                    }}
                    disabled
                    value={order.service_description}
                  ></textarea>
                </div>

                <div className="textbox-gray">
                  <label htmlFor="companyName">Month</label>
                  <input type="number" value={order.month} required disabled />
                </div>

                <div className="textbox-gray">
                  <label htmlFor="picName">Quantity</label>
                  <input type="number" value={order.cable_quantity} disabled />
                </div>

                <div className="textbox-gray">
                  <label htmlFor="companyName">Unit</label>
                  <input type="text" value={order.unit} required disabled />
                </div>

              </div>

              <div className="destination-information">
                <div className="title-order-input">
                  <h5 style={{ visibility: "hidden" }}>.</h5>
                </div>
                <label htmlFor="nrc" style={{ fontSize: "18px" }}>
                  OTC Charging Scheme
                </label>
                <div className="textbox-gray">
                  <label htmlFor="nrc">Unit Price ({viewQuotation.xcp_quotation_currency})</label>
                  <input
                    type="text"
                    value={formatCurrency(order.quotation_otc)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">Subtotal ({viewQuotation.xcp_quotation_currency})</label>
                  <input
                    type="text"
                    value={formatCurrency(order.quotation_otc_sub_total)}
                    required
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </div>

                <div className="title-order-input"></div>
                <label htmlFor="picName" style={{ fontSize: "18px" }}>
                  MRC Charging Scheme
                </label>
                <div className="textbox-gray">
                  <label htmlFor="picName">
                    Unit Price ({viewQuotation.xcp_quotation_currency})
                  </label>
                  <input
                    type="text"
                    value={formatCurrency(order.quotation_mrc)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName1">
                    Subtotal ({viewQuotation.xcp_quotation_currency})
                  </label>
                  <input
                    type="text"
                    value={formatCurrency(order.quotation_mrc_sub_total)}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
            ))} 

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Agreement Details</h5>
            </div>
            <div className="radio-button">
              <label>Terms & Conditions</label>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="general-tc"
                  value="GENERAL"
                  checked={viewQuotation.xcp_quotation_tc_option === "GENERAL"}
                  disabled
                  required
                />
                <label htmlFor="general-tc">
                  Use general terms & conditions
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="specified-tc"
                  value="SPECIFIED"
                  checked={viewQuotation.xcp_quotation_tc_option === "SPECIFIED"}
                  disabled 
                />
                <label htmlFor="specified-tc">Specified T&C</label>
              </div>
              <textarea
                value={viewQuotation.xcp_quotation_tc}
                style={{
                  width: "100%",
                  marginTop: "8px",
                  padding: "8px",
                  height: "400px",
                }}
                disabled 
                required
              />
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Total Project Value</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">
                Total OTC Price ({viewQuotation.xcp_quotation_currency})
              </label>
              <input
                type="text"
                value={formatCurrency(viewQuotation.xcp_quotation_otc_total)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">
                Total MRC Price ({viewQuotation.xcp_quotation_currency})
              </label>
              <input
                type="text"
                value={formatCurrency(viewQuotation.xcp_quotation_mrc_total)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
          </div>
          <input
            type="button"
            className="btn-submit-order-input"
            value="Back"
            onClick={handleBackClick}
          />
          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>
    </div>
  );
};

export default ViewQuotation;
